<template>
    <div>
        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <h1 class="h2">Gestion des indulgences</h1>
        </div>

        <div class="mb-3 background-alt parent">
            <div class="col-lg-12 mt-3 mb-3">
                <div class="row">
                    <span class="centerFilter">Filtrer : </span>
                    <button class="btn btn-info btnFilter" v-for="(filtre, index) in arrayFilter" v-show="filtre !== ''"
                            @click="deleteFilter(index)">
                        {{ filtre.label }} <i class="fas fa-times"/>
                    </button>
                </div>

                <div class="row">
                    <div class="col-lg-4 mt-2 mb-2">
                        <v-select class="select background-alt" :options="officers" v-model="officer"/>
                    </div>
                    <div class="col-lg-4 mt-2 mb-2">
                        <v-select class="select background-alt" :options="vehicles" v-model="vehicle"/>
                    </div>
                    <div class="col-lg-4 mt-2 mb-2">
                        <v-select class="select background-alt" :options="devices" v-model="device"/>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-4 mt-2 mb-2">
                        <date-picker ref="datePickerComponent"/>
                    </div>
                    <div class="col-lg-4 mt-2 mb-2">
                        <v-select class="select background-alt" :options="arrayMercyReasons"
                                  v-model="mercyReason"/>
                    </div>
                    <div class="col-lg-4 mt-2 mb-2">
                        <v-select class="select background-alt" :options="lines" v-model="line"/>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-4 row ml-auto pl-0 mt-2 mb-2">
                        <div class="col-lg-6 pl-0 pt-xs-2">
                            <button class="btn btn-custom w-100" @click="filter()" title="Rechercher">Rechercher
                            </button>
                        </div>
                        <div class="col-lg-6 pl-0 pt-xs-2">
                            <button class="btn btn-custom w-100" @click="initFilter"
                                    title="Réinitialiser la recherche">Réinitialiser
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mb-3">
            <div class="col-lg-12 background-alt">
                <vue-element-loading :active="isActiveChart" spinner="spinner" class="customLoader" color="#a3285e"/>

                <line-chart :chart-data="dataChart"
                            chartId="bar-chart-1"
                            :options="{responsive: true, maintainAspectRatio: false,beginAtZero: true}"/>
            </div>
        </div>

        <div class="mb-3 background-alt">

            <div class="d-flex justify-content-end mb-4">
                <a
                    class="btn btn-custom text-white"
                    title="Export les indulgences"
                    @click="showCsvDownloadModal = true"
                >
                    Exporter
                </a>
            </div>

            <div class="table-responsive">
                <vuetable ref="vuetable"
                          api-url="/api/mercies/table"
                          :fields="fields"
                          pagination-path=""
                          class="table"
                          :append-params="moreParams"
                          :http-options="{ headers: { 'Authorization': 'Bearer ' + api_token }}"
                          @vuetable:pagination-data="onPaginationData"
                          no-data-template="">
                </vuetable>
            </div>

            <div class="row col-lg-12 pr-0">
                <div class="mr-auto">
                    <vuetable-pagination-info ref="paginationInfo"
                                              class="alert alert-info tablePagination"
                                              info-template="Affichage de {from} à {to} sur {total} d'indulgences"
                                              no-data-template="Aucune indulgence"/>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                                         @vuetable-pagination:change-page="onChangePage"
                                         :css="css.pagination"/>
                </div>
            </div>
        </div>

        <csv-download-modal
            :show-modal="showCsvDownloadModal"
            :download-url="'/download/mercies?mercyReason=' + this.urlParam"
            file-name-prefix="IER-Indulgences-"
            @closeModal="showCsvDownloadModal = false"
        />

        <infringement-search-result-modal/>

    </div>
</template>

<script>

    import moment from 'moment';
    import Vue from 'vue';
    import Vuetable from 'vuetable-2';
    import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
    import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo';
    import vSelect from 'vue-select';
    import LineChart from './layout/LineChart';
    import DatePicker from './layout/DateRangePicker';
    import axios from 'axios';
    import VueElementLoading from 'vue-element-loading';
    import InfringementSearchResultModal from "./layout/InfringementSearchResultModal";
    import CsvDownloadModal from "./layout/CsvDownloadModal";

    export default {
        components: {
            vSelect,
            LineChart,
            Vuetable,
            VuetablePagination,
            VuetablePaginationInfo,
            DatePicker,
            VueElementLoading,
            InfringementSearchResultModal,
            CsvDownloadModal
        },
        computed: {
            api_token() {
                return api_token;
            }
        },
        data() {
            return {
                moreParams: {},
                dataChart: {},
                urlParam: '',
                isActiveChart: true,
                showCsvDownloadModal: false,

                arrayMercyReasons: [],
                lines: [],
                vehicles: [],
                devices: [],
                officers: [],

                mercyReason: '',
                dateStart: '',
                dateEnd: '',
                line: '',
                vehicle: '',
                device: '',
                officer: '',

                arrayFilter: {
                    mercyReason: '',
                    date: '',
                    line: '',
                    vehicle: '',
                    terminal: '',
                    officer: '',
                    device: '',
                },

                fields: [
                    {
                        name: 'mercy_id',
                        title: 'Numéro'
                    },
                    {
                        name: 'date',
                        title: 'Date'
                    },
                    {
                        name: 'mercy_reason',
                        title: 'Motif'
                    },
                    {
                        name: 'officer',
                        title: 'Agent'
                    },
                    {
                        name: 'vehicle',
                        title: 'Véhicule'
                    },
                    {
                        name: 'line',
                        title: 'Ligne'
                    },
                    {
                        name: 'gender-slot',
                        title: '',
                    },
                ],

                css: {
                    pagination: {
                        activeClass: 'btn-custom',
                        disabledClass: 'disabled',
                        pageClass: 'btn btn-border',
                        linkClass: 'btn btn-border',
                        icons: {
                            first: '',
                            prev: '',
                            next: '',
                            last: '',
                        }
                    }
                }
            }
        },
        watch: {
            mercyReason: function () {
                if (this.mercyReason.id) {
                    this.arrayFilter.mercyReason = this.mercyReason;
                }
            },
            line: function () {
                if (this.line.id) {
                    this.arrayFilter.line = this.line;
                }
            },
            vehicle: function () {
                if (this.vehicle.id) {
                    this.arrayFilter.vehicle = this.vehicle;
                }
            },
            officer: function () {
                if (this.officer.id) {
                    this.arrayFilter.officer = this.officer;
                }
            },
            device: function () {
                if (this.device.id) {
                    this.arrayFilter.device = this.device;
                }
            },
        },
        created() {
            axios.get('/api/parameters/value?key=web.dashboard.mercy.period')
                .then(result => {
                    this.dateDefine = result.data;
                    this.dateStart = moment().subtract(this.dateDefine - 1, 'd').format('YYYY-MM-DD');
                    this.dateEnd = moment().format('YYYY-MM-DD');
                    this.initFilter();
                });
        },
        methods: {
            onPaginationData(paginationData) {
                this.$refs.pagination.setPaginationData(paginationData);
                this.$refs.paginationInfo.setPaginationData(paginationData)
            },

            onChangePage(page) {
                this.$refs.vuetable.changePage(page)
            },

            getLine() {
                this.lines = [];
                this.arrayFilter.line = '';
                this.line = {id: '', label: 'Ligne'};
                axios.get('/api/lines')
                    .then(result => {
                        _.forEach(result.data, value => {
                            this.lines.push(
                                {
                                    id: value.id,
                                    label: value.label,
                                }
                            );
                        })
                    })
            },

            getVehicle() {
                this.vehicles = [];
                this.vehicle = {id: '', label: 'Véhicule'};
                this.arrayFilter.vehicle = '';
                axios.get('/api/vehicles')
                    .then(result => {
                        _.forEach(result.data, value => {
                            this.vehicles.push(
                                {
                                    id: value.id,
                                    label: value.label,
                                }
                            );
                        })
                    })
            },

            getDevice() {
                this.devices = [];
                this.device = {id: '', label: 'Terminal'};
                this.arrayFilter.device = '';
                axios.get('/api/officers')
                    .then(result => {
                        let arrayDevice = _.orderBy(result.data.data, 'single_key', 'asc');
                        _.forEach(arrayDevice, value => {
                            this.devices.push(
                                {
                                    id: value.id,
                                    imei: value.imei,
                                    label: value.single_key.toString(),
                                }
                            );
                        })
                    })
            },

            getOfficer() {
                this.officers = [];
                this.officer = {id: '', label: 'Agent'};
                this.arrayFilter.officer = '';
                axios.get('/api/officers')
                    .then(result => {
                        _.forEach(result.data, value => {
                            let name = value.registration_number + " - " + value.last_name + " " + value.first_name;
                            value.deleted_at !== null ? name = name + " (supprimé)" : name;
                            this.officers.push(
                                {
                                    id: value.id,
                                    label: name,
                                }
                            );
                        });
                    })
            },

            getMercyReason() {
                this.arrayMercyReasons = [];
                this.mercyReason = {id: '', label: 'Motif'};
                this.arrayFilter.mercyReason = '';
                axios.get('/api/repositories/mercyReason')
                    .then(result => {
                        let arrayReason = _.orderBy(result.data.data, 'label', 'asc');
                        _.forEach(arrayReason, value => {
                            this.arrayMercyReasons.push(
                                {
                                    id: value.id,
                                    label: value.label,
                                }
                            );
                        })
                    })
                    .catch(error => {
                        console.log(error.message)
                    });
            },

            initData() {
                this.arrayFilter.date = '';
                this.dateStart = moment().subtract(this.dateDefine - 1, 'd').format('YYYY-MM-DD');
                this.dateEnd = moment().format('YYYY-MM-DD');
                this.$refs.datePickerComponent.range = {
                    startDate: new Date(moment().subtract(this.dateDefine - 2, 'd').format('YYYY-MM-DD')),
                    endDate: new Date(moment().add(1, 'd').format('YYYY-MM-DD'))
                };
            },

            getUrlParam() {
                this.urlParam = '?mercyReason=' + this.mercyReason.id + "&start=" + this.dateStart + "&end=" + this.dateEnd + '&line=' + this.line.id
                    + "&officer=" + this.officer.id + "&vehicle=" + this.vehicle.id + "&device=" + this.device.imei;
            },

            initFilter() {
                this.getMercyReason();
                this.getLine();
                this.getVehicle();
                this.getDevice();
                this.getOfficer();
                this.initData();
                this.getUrlParam();
                this.filter();
            },

            deleteFilter(index) {
                this.arrayFilter[index] = '';

                switch (index) {
                    case 'mercyReason':
                        this.arrayFilter.mercyReason = '';
                        this.mercyReason = {id: '', label: 'Raison'};
                        break;
                    case 'officer':
                        this.arrayFilter.officer = '';
                        this.officer = {id: '', label: 'Agent'};
                        break;
                    case 'vehicle':
                        this.arrayFilter.vehicle = '';
                        this.vehicle = {id: '', label: 'Vehicule'};
                        break;
                    case 'line':
                        this.arrayFilter.line = '';
                        this.line = {id: '', label: 'Ligne'};
                        break;
                    case 'device':
                        this.arrayFilter.device = '';
                        this.device = {id: '', imei: '', label: 'Terminal'};
                        break;
                    case 'date':
                        this.arrayFilter.date = '';
                        this.dateStart = moment().subtract(this.dateDefine - 1, 'd').format('YYYY-MM-DD');
                        this.dateEnd = moment().format('YYYY-MM-DD');
                        this.$refs.datePickerComponent.range = {
                            startDate: new Date(moment().subtract(this.dateDefine - 2, 'd').format('YYYY-MM-DD')),
                            endDate: new Date(moment().add(1, 'd').format('YYYY-MM-DD'))
                        };
                        break;
                }
            },

            getDate(start, end, date) {
                this.arrayFilter.date = {id: 1, label: date};
                this.dateStart = start;
                this.dateEnd = end;
            },

            filter() {
                this.isActiveChart = true;
                this.getUrlParam();
                this.updateVueTable();
                this.updateGraphic();
            },

            updateGraphic() {
                axios.get('/api/mercies/graph' + this.urlParam)
                    .then(result => {
                        let dataChart = {
                            labels: [],
                            datasets: [
                                {
                                    label: 'Nombre d\'indulgences',
                                    backgroundColor: "rgba(30, 132, 73, 0.3)",
                                    data: []
                                }
                            ]
                        };
                        _.forEach(result.data, value => {
                            if (this.dateStart === this.dateEnd) {
                                dataChart.labels.push(moment(value.name.date).format('HH') + 'h');
                                dataChart.datasets[0].data.push(value.value);
                            } else {
                                dataChart.labels.push(moment(value.name.date).format('DD/MM/YYYY'));
                                dataChart.datasets[0].data.push(value.value);
                            }
                        });
                        this.dataChart = dataChart;
                        this.isActiveChart = false;
                    })
                    .catch(error => {
                        console.log(error.message)
                    });
            },

            updateVueTable() {
                this.moreParams = {
                    'mercyReason': this.mercyReason.id,
                    'line': this.line.id,
                    'officer': this.officer.id,
                    'vehicle': this.vehicle.id,
                    'start': this.dateStart,
                    'end': this.dateEnd,
                    'device': this.device.imei
                };
                Vue.nextTick(() => this.$refs.vuetable.refresh());
            }
        },
    }
</script>

<style>
    .customLoader {
        z-index: 0 !important;
    }
</style>


// WEBPACK FOOTER //
// resources/js/components/Mercy.vue